import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import {
  IConfigPageReq,
  IConfigPageRes,
  ICreateConfigInfoReq,
  ICreateConfigInfoRes,
  IUpdateConfigInfoReq,
  IUpdateConfigInfoRes,
  IRetrieveConfigInfoRes,
  IConfigEnable,
  IMessagePageReq,
  IMessagePageRes,
  IMessageInfoRes,
  IMessageRetryReq,
  ILogPageReq,
  ILogPageRes,
  ILogInfoRes,
  IBoundSendRecordPageReq,
  IBoundSendRecordPageRes,
  ISsoDetailRes,
  ISsoLogPageRes,
  IConfigSyncConfigByEnvReq,
  IConfigRedeclareReq,
  IConfigRedeclareRes,
  IConfigGetServiceNamesRes,
} from './type.d';

/**
 * 配置查询
 */
export function getConfigList(data: IConfigPageReq) {
  return http.post<IConfigPageRes>({
    url: '/mq/ops/v1/config/page',
    loading: true,
    data,
  });
}

/**
 * 配置新增
 */
export function createConfigInfo(data: ICreateConfigInfoReq) {
  return http.post<ICreateConfigInfoRes>({
    url: '/mq/ops/v1/config/info',
    loading: true,
    data,
  });
}

/**
 * 配置编辑
 */
export function updateConfigInfo(data: IUpdateConfigInfoReq) {
  return http.put<IUpdateConfigInfoRes>({
    url: '/mq/ops/v1/config/info',
    loading: true,
    data,
  });
}

/**
 * 配置详情
 */
export function retrieveConfigInfo(id: string) {
  return http.get<IRetrieveConfigInfoRes>({
    url: `/mq/ops/v1/config/info/${id}`,
    loading: true,
  });
}

/**
 * 配置停用|启用
 */
export function updateConfigEnable(enable: IConfigEnable, id: string) {
  return http.put({
    url: `/mq/ops/v1/config/enable/${enable}/${id}`,
    loading: true,
  });
}

/**
 * 导入配置
 */
export function importConfig(data: FormData) {
  return http.post({
    url: '/mq/ops/v1/config/import',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
}

/**
 * SSO查询
 */
export const getSsoCenterList = (params: ILogPageReq) => {
  const url = '/sso-center/web/v1/log/page';
  return http.post<ISsoLogPageRes>({
    url,
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
/**
 * SSO详情
 */
export function getSsoInfo(id: string) {
  return http.get<ISsoDetailRes>({
    url: `/sso-center/web/v1/log/info/${id}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}
/**
 * 消息查询
 */
export function getMessageList(data: IMessagePageReq) {
  return http.post<IMessagePageRes>({
    url: '/mq/ops/v1/message/page',
    loading: true,
    data,
  });
}

/**
 * 消息详情
 */
export function getMessageInfo(id: string) {
  return http.get<IMessageInfoRes>({
    url: `/mq/ops/v1/message/info/${id}`,
    loading: true,
  });
}

/**
 * 消息重试
 */
export function messageRetry(data: IMessageRetryReq) {
  return http.put({
    url: '/mq/ops/v1/message/retry',
    loading: true,
    data,
  });
}

/**
 * 日志查询
 */
export function getLogList(data: ILogPageReq) {
  return http.post<ILogPageRes>({
    url: '/mq/ops/v1/log/page',
    loading: true,
    data,
  });
}

/**
 * 日志详情
 */
export function getLogInfo(id: string) {
  return http.get<ILogInfoRes>({
    url: `/mq/ops/v1/log/info/${id}`,
    loading: true,
  });
}

/**
 * 告警消息查询
 */
export function getAlarmMessageList(data: IBoundSendRecordPageReq) {
  return http.post<IBoundSendRecordPageRes>({
    url: '/management/web/v1/bound-send-record/page',
    loading: true,
    data,
  });
}
/*
 * 获取环境列表
 */
export function getEnvList() {
  return http.get({
    url: '/communal/domain/conf/env-list',
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}
/**
 * 批量同步到指定环境
 */
export function syncConfigByEnv(data: IConfigSyncConfigByEnvReq) {
  return http.post({
    url: '/mq/ops/v1/config/sync-config-by-env',
    loading: true,
    data,
  });
}
/**
 * OPS - 绑定关系重新声明
 * @see https://yapi.ibaibu.com/project/1758/interface/api/217777
 */
export const configRedeclare = (params: IConfigRedeclareReq) => {
  const url = '/mq/ops/v1/config/redeclare';
  return http.post<IConfigRedeclareRes>({
    url,
    data: params,
    loading: true,
  });
};
/**
 * OPS - 获取【nacos】服务列表
 * @see https://yapi.ibaibu.com/project/1758/interface/api/218177
 */
export const configGetServiceNames = (keyword: string) => {
  const url = '/mq/ops/v1/config/getServiceNames';
  return http.get<IConfigGetServiceNamesRes>({
    url,
    loading: true,
    params: { keyword },

  });
};
